import React from "react";
import { FormControl, Button } from "react-bootstrap";
import ajax from "../../lib/ajax.js";
import context from "../../lib/context.js";

export default class StringAutoComplete extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            selectedItems: []
        };

        this.loadItems = this.loadItems.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.input = null;
        this.autoComplete = null;
    }    

    componentDidMount() {
        if (this.multiple() && this.props.data) {
            this.setState({selectedItems: this.props.data });
        }
    }

    componentWillReceiveProps(currProps) {
        if (this.multiple() == false) {
            this.input.value = currProps.value;
        }
    }

    loadItems(prefix) {
        if (prefix.trim() == '') {
            this.setState({
                items: []
            });
            this.autoComplete.className = this.autoComplete.className.replace('ap-hidden', '') + ' ap-hidden';
            return false;
        }

        this.autoComplete.className = this.autoComplete.className.replace('ap-hidden', '');

        let data = {
            rows: this.props.rows,
            prefix: prefix
        }
        
        let self = this;
        ajax.api().post(`${this.props.url}`, data)
            .then(function (res) {
                self.setState({ items: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onKeyUp(event) {
        this.loadItems(event.target.value)
    }

    onBlur(event) {
        var value = event.target.value.trim();

        if (this.capitalized() == true)
            value = value.toUpperCase();

        if (this.props.allowedLength !== undefined)
            if (value.length > this.props.allowedLength) {
                value = value.substr(0, this.props.allowedLength);
            }

        this.input.value = value;
        this.autoComplete.className = this.autoComplete.className.replace('ap-hidden', '') + ' ap-hidden';

        if (this.props.onChange && this.props.value != value) {    
            this.props.onChange(value, value, this.props.dataKey);
        }

        if (this.props.onSelect && this.props.value != value) {
            this.props.onSelect(null, value);
        }
    }

    onSelect(item) {
        if (this.multiple() == false) {
            if (this.props.onChange) {
                this.props.onChange(item[this.props.valueField], item[this.props.descriptionField], this.props.dataKey);
                this.input.value = item[this.props.valueField];
            }
    
            if (this.props.onSelect) {
                this.props.onSelect(item);
                this.input.value = item[this.props.valueField];
            }
        }
        else {
            var selectedItems = this.state.selectedItems;

            if (selectedItems.filter(x => x.code == item[this.props.valueField]).length == 0) {
                selectedItems.push({
                    code: item[this.props.valueField],
                    description: item[this.props.descriptionField]
                });
                this.setState({ selectedItems: selectedItems });
            }

            if (this.props.onMultipleSelect) {
                this.props.onMultipleSelect(this.state.selectedItems)
            }
        }

        this.autoComplete.className = this.autoComplete.className.replace('ap-hidden', '') + ' ap-hidden';
    }

    capitalized() {
        if (this.props.capitalized !== undefined)
            return this.props.capitalized;
        return false;
    }

    multiple() {
        if (this.props.multiple !== undefined)
            return this.props.multiple;
        return false;
    }

    render() {
        var rows = [];
        var readOnly = false;

        if (this.props.readOnly !== undefined)
            readOnly = this.props.readOnly;
        
        const self = this;

        this.state.items.map(function (item, i) {
            var tds = [];
            self.props.valueFields.forEach(function(field, i) {
                tds.push(<td onMouseDown={() => self.onSelect(item)}>{item[field.field]}</td>);
            });
            rows.push(<tr className="ap-autocomplete-dropdown-item">{tds}</tr>);
        }, this);

        if (readOnly == false) {
            return (
                <div className="ap-report-control-dropdown">
                    {
                        (this.multiple() == false) ? 
                            <FormControl
                                id={this.props.id + '-input'}
                                type="text"
                                defaultValue={this.props.value}
                                onKeyUp={this.onKeyUp}
                                className={this.props.className}
                                readOnly={this.props.readOnly}
                                placeholder={this.props.placeholder}
                                maxLength={this.props.maxLength}
                                onFocus={this.onKeyUp}
                                onBlur={this.onBlur}
                                inputRef={ref => this.input = ref}
                                style={{ "marginBottom" : "0px" }} /> :
                            <div className="input-group">
                                <FormControl
                                    id={this.props.id + '-input'}
                                    type="text"
                                    defaultValue={this.props.value}
                                    onKeyUp={this.onKeyUp}
                                    className={this.props.className}
                                    readOnly={this.props.readOnly}
                                    placeholder={this.props.placeholder}
                                    maxLength={this.props.maxLength}
                                    onFocus={this.onKeyUp}
                                    onBlur={this.onBlur}
                                    inputRef={ref => this.input = ref}
                                    style={{ "marginBottom" : "0px" }} />
                                <span className="input-group-btn">
                                    <Button placeholder="Add" onClick={() => { 
                                            var value = self.input.value.trim();
                                            if (self.input.value.trim() != '' && 
                                                self.state.selectedItems.filter(x => x.code.toLowerCase() == value.toLowerCase()).length == 0) {
                                                var selectedItems = self.state.selectedItems;
                                                selectedItems.push({
                                                    code: value,
                                                    description: value
                                                });
                                                self.setState({ selectedItems: selectedItems }); 

                                                if (self.props.onMultipleSelect) self.props.onMultipleSelect(selectedItems);
                                            }
                                        }}>
                                        <span className="fa fa-plus-circle ap-green-color">    
                                        </span>
                                    </Button>
                                    <Button placeholder="Remove All" onClick={() => { 
                                            self.setState({ selectedItems: [] }); 
                                            if (self.props.onMultipleSelect) self.props.onMultipleSelect([]);
                                        }} >
                                        <span className="fa fa-times-circle ap-green-color">    
                                        </span>
                                    </Button>
                                </span>
                            </div>
                    }
                    
                    <div className="ap-autocomplete-dropdown ap-hidden" ref={ref => this.autoComplete = ref} >
                        <table>
                            <thead>
                                <tr>{this.props.valueFields.map(function(item, i) { return <th>{item.header}</th>})}</tr>
                            </thead>
                            <tbody>
                                {rows}
                            </tbody>
                        </table>
                    </div>
                    {
                        (this.multiple() == true) ? 
                            <div className="ap-autocomplete-multiple-list">
                                {this.state.selectedItems.map(function(item, i) { 
                                    return <div className="item">
                                            <span>{item.description}</span>
                                            <span onClick={() => { 
                                                    var selectedItems = self.state.selectedItems.filter(x => x.code.toLowerCase() != item.code.toLowerCase());
                                                    self.setState({ selectedItems: selectedItems }); 
                                                    if (self.props.onMultipleSelect) self.props.onMultipleSelect(selectedItems);
                                                }} className="fa fa-times-circle ap-green-color remove pull-right">    
                                            </span>
                                        </div>
                                })}
                            </div> 
                            : ''
                    }
                </div>
            );
        }
        else {
            return (
                <div className="ap-report-control-dropdown"><div><ControlLabel className="ap-report-control-label ap-black-color">{this.props.value}</ControlLabel></div></div>
            );
        }
    }
}